// 004 (FR-046; research R12): keeps the header school on the selected child's school. Mounted in
// the parent area layout: loads the children once and re-syncs whenever the list changes.
import { useEffect } from "react";

import { useCurrentSchool } from "@/school-identity/CurrentSchoolProvider";

import { appSelection } from "./selection";
import { useParentData } from "./useParentData";

export function ParentDataSync() {
  const { students, actions } = useParentData();
  const [, setSchool] = useCurrentSchool();
  const loaded = students.data !== null;

  useEffect(() => {
    if (!loaded) void actions.refreshStudents();
  }, [loaded, actions]);

  useEffect(() => {
    appSelection.sync(students.data, setSchool);
  }, [students.data, setSchool]);

  return null;
}
